import { DONATION_ROUTES } from '@/constants';
import { getStaticCdnUrl } from '@/utils';
import { checkTodayInRange } from '@/utils/checkTodayInRange';

type CardPromotionConfig = {
  id: string;
  title: string;
  range: readonly [string, string];
  imageUrl: string;
  inlineImageUrl: string;
  /** 원본 자산 픽셀 크기 — 슬롯 비율이 여기서 파생되므로 자산 교체 시 함께 갱신한다 */
  inlineImageWidth: number;
  inlineImageHeight: number;
  inlineAlt: string;
  href: string;
};

const CARD_PROMOTION_CONFIGS: CardPromotionConfig[] = [
  {
    id: 'kb',
    title: 'KB국민카드X웰로',
    range: ['2026-08-01T00:00:00+09:00', '2026-08-31T23:59:59+09:00'],
    imageUrl: getStaticCdnUrl(
      'kb-card-event/donation-home-kb-card-banner-2608.png',
    ),
    inlineImageUrl: getStaticCdnUrl(
      'kb-card-event/donation-order-detail-kb-card-banner-2608.png',
    ),
    inlineImageWidth: 1125,
    inlineImageHeight: 360,
    inlineAlt: 'KB국민카드 체크카드 이벤트 배너',
    href: DONATION_ROUTES.KB_CHECK_CARD.pathname,
  },
];

// --- Derived exports ---

const activeConfigs = CARD_PROMOTION_CONFIGS.filter((config) =>
  checkTodayInRange(config.range[0], config.range[1]),
);

export const CARD_PROMOTIONS = {
  inline: activeConfigs.map((config) => ({
    href: config.href,
    imageUrl: config.inlineImageUrl,
    width: config.inlineImageWidth,
    height: config.inlineImageHeight,
    alt: config.inlineAlt,
  })),
  main: activeConfigs.map((config) => ({
    imageUrl: config.imageUrl,
    href: config.href,
    title: config.title,
  })),
};
